import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

const products = [
  {
    badge: 'ERP Solution',
    gradient: 'from-blue-500 to-cyan-500',
    badgeColor: 'bg-blue-100 text-blue-700',
    icon: (
      <svg className="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
      </svg>
    ),
    title: 'Cloud ERP System Solution',
    tagline: 'Comprehensive cloud-based enterprise resource planning for multi-entity businesses',
    description: 'Our fully managed ERP offers a comprehensive cloud-based ecosystem for multi-entity financial management. Available via web and mobile, it streamlines complex accounting, real-time reporting, and intercompany consolidations. Experience seamless automation and secure, centralized data control across all your business branches, ensuring your financial operations remain agile, compliant, and scalable in a digital-first world.',
    features: [
      'Multi-Entity Consolidation',
      'Real-Time Accounting',
      'Automated Reconciliation',
      'Cross-Platform Access (Web & Mobile)',
      'Fully Managed Infrastructure',
      'Multi-Currency & Tax Engine',
      'Role-Based Access Control'
    ],
    cta: 'Request a Demo'
  },
  {
    badge: 'CRM Platform',
    gradient: 'from-purple-500 to-pink-500',
    badgeColor: 'bg-purple-100 text-purple-700',
    icon: (
      <svg className="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z" />
      </svg>
    ),
    title: 'Scalizap Core CRM',
    tagline: 'Centralized cloud hub for mastering customer relationships across web and mobile',
    description: 'Our fully managed Core CRM provides a centralized cloud hub for mastering customer relationships across web and mobile. Effortlessly track leads, automate sales workflows, and access deep pipeline analytics from anywhere. Designed for scalability, it ensures seamless team collaboration and personalized engagement, empowering your business to convert prospects into loyal partners with data-driven precision.',
    features: [
      '360° Lead Tracking',
      'Automated Workflows',
      'Contact Management',
      'Real-Time Dashboards',
      'Forecasting Tools',
      'Mobility & Integration',
      'ERP Readiness',
      'Support Ticketing',
      'Task & Calendar Sync'
    ],
    cta: 'See Live Demo'
  },
  {
    badge: 'HR Management',
    gradient: 'from-green-500 to-teal-500',
    badgeColor: 'bg-green-100 text-green-700',
    icon: (
      <svg className="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
      </svg>
    ),
    title: 'Scalizap HRM',
    tagline: 'Robust cloud-based platform for modern workforce management and HR automation',
    description: 'Our fully managed HRM solution provides a robust, cloud-based platform for modern workforce management. Available on web and mobile, it automates payroll, attendance tracking, and performance evaluations seamlessly. Empower your HR team with centralized employee records, self-service portals, and advanced talent analytics, ensuring a compliant, engaged, and highly productive organization across every department and location.',
    features: [
      'Centralized Employee Database',
      'Automated Onboarding & Offboarding',
      'Performance & Appraisals',
      'Precision Attendance Tracking',
      'Leave Management',
      'Integrated Payroll Engine',
      'Employee Self-Service Portal',
      'Manager Dashboards',
      'Regulatory Compliance',
      'HR Analytics'
    ],
    cta: 'Get Started'
  },
  {
    badge: 'POS System',
    gradient: 'from-orange-500 to-red-500',
    badgeColor: 'bg-orange-100 text-orange-700',
    icon: (
      <svg className="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-3 7h3m-3 4h3m-6-4h.01M9 16h.01" />
      </svg>
    ),
    title: 'Restaurant & Café POS',
    tagline: 'High-speed, cloud-based solution for seamless dining operations management',
    description: 'Our fully managed Restaurant and Cafe POS provides a high-speed, cloud-based solution for seamless dining operations. Available on web and mobile, it integrates table management, real-time inventory tracking, and split-billing effortlessly. Enhance guest experiences with integrated digital menus and kitchen display systems, ensuring your front-of-house and kitchen stay perfectly synced for maximum efficiency and growth.',
    features: [
      'Smart Order Management',
      'Table & Floor Mapping',
      'KDS (Kitchen Display System)',
      'Multi-Mode Ordering',
      'Inventory & Menu Control',
      'Real-Time Ingredient Tracking',
      'Recipe Management',
      'Dynamic Menu Updates',
      'End-of-Day (EOD) Reporting'
    ],
    cta: 'Request a Demo'
  },
  {
    badge: 'E-Commerce',
    gradient: 'from-indigo-500 to-purple-500',
    badgeColor: 'bg-indigo-100 text-indigo-700',
    icon: (
      <svg className="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293c-.63.63-.184 1.707.707 1.707H17m0 0a2 2 0 100 4 2 2 0 000-4zm-8 2a2 2 0 11-4 0 2 2 0 014 0z" />
      </svg>
    ),
    title: 'Multi-vendor E-Commerce',
    tagline: 'Scalable cloud-based marketplace platform for diverse multi-vendor operations',
    description: 'Our fully managed Multi-vendor E-commerce platform offers a scalable, cloud-based marketplace for diverse sellers. Available via web and mobile, it features unified vendor dashboards, secure payment gateways, and automated commission tracking. Empower your business with advanced logistics integration, real-time inventory synchronization, and personalized buyer experiences, creating a seamless, high-growth digital storefront for global or local trade.',
    features: [
      'Dedicated Vendor Dashboards',
      'Automated Commission Management',
      'Bulk Product Upload',
      'Intelligent Search & Filters',
      'Multi-Vendor Cart',
      'Real-Time Order Tracking',
      'Admin & Platform Control',
      'Vendor Approval Workflow',
      'Unified Payment Gateway',
      'Inventory Sync'
    ],
    cta: 'Explore Platform'
  },
  {
    badge: 'Mobile POS',
    gradient: 'from-emerald-500 to-teal-500',
    badgeColor: 'bg-emerald-100 text-emerald-700',
    icon: (
      <svg className="w-10 h-10" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M8 7h12m0 0l-4-4m4 4l-4 4m0 5H4m0 0l4 4m-4-4l4-4" />
      </svg>
    ),
    title: 'Van Sale POS Application',
    tagline: 'High-efficiency mobile distribution management for on-field sales operations',
    description: 'Our fully managed Van Sale POS transforms mobile distribution into a high-efficiency operation via cloud-based web and mobile apps. Streamline on-field invoicing, real-time stock tracking, and route optimization effortlessly. Empower your drivers with offline transaction capabilities, instant digital receipts, and GPS-integrated delivery management, ensuring complete transparency and synchronized financial data from the road to your core ERP.',
    features: [
      'On-the-Spot Invoicing',
      'Offline Mode',
      'Multi-Payment Support',
      'Route Optimization & GPS',
      'Visit Scheduling',
      'Van Inventory Management',
      'Dynamic Pricing & Discounts',
      'Credit Limit Alerts',
      'Stock Requisition',
      'End-of-Day Settlement',
      'ERP Integration'
    ],
    cta: 'Request a Demo'
  }
];

const ProductsPage = () => {
  const [isVisible, setIsVisible] = useState(false);
  const contentRef = useRef(null);

  useEffect(() => { window.scrollTo(0, 0); }, []);

  useEffect(() => {
    const fallback = setTimeout(() => setIsVisible(true), 120);
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) { clearTimeout(fallback); setIsVisible(true); } },
      { threshold: 0.05 }
    );
    if (contentRef.current) observer.observe(contentRef.current);
    return () => {
      clearTimeout(fallback);
      if (contentRef.current) observer.unobserve(contentRef.current);
    };
  }, []);

  return (
    <>
      <title>Business Software &amp; POS Solutions Kerala, India | Scalizap</title>
      <meta name="description" content="Explore Scalizap's business software solutions, POS systems, automation tools, and digital products designed to streamline operations and improve business efficiency across India." />
      <Header />

      {/* Hero */}
      <section className="relative pt-32 pb-20 bg-gradient-to-br from-slate-900 via-blue-900 to-slate-900 overflow-hidden">
        <div className="absolute inset-0 overflow-hidden">
          <div className="absolute -top-40 -right-40 w-96 h-96 bg-blue-500/10 rounded-full blur-3xl"></div>
          <div className="absolute -bottom-40 -left-40 w-96 h-96 bg-cyan-500/10 rounded-full blur-3xl"></div>
        </div>
        <div className="container-custom relative z-10 text-center text-white">
          <span className="inline-block text-white/70 text-xs font-semibold uppercase tracking-widest mb-4 bg-white/10 px-4 py-1.5 rounded-full">
            Built by Scalizap
          </span>
          <h1 className="font-display text-4xl md:text-5xl lg:text-6xl font-bold mb-6">
            Our <span className="gradient-text">Products</span>
          </h1>
          <div className="w-24 h-1 bg-gradient-to-r from-blue-400 to-cyan-400 mx-auto mb-6"></div>
          <p className="text-lg md:text-xl text-white/80 max-w-3xl mx-auto leading-relaxed">
            Purpose-built software products designed to solve real business challenges — available as SaaS subscriptions or fully customizable on-premise deployments.
          </p>
        </div>
      </section>

      {/* Products */}
      <section ref={contentRef} className="section-padding bg-slate-50">
        <div className="container-custom">
          <div className={`text-center mb-16 ${isVisible ? 'animate-fadeInUp' : 'opacity-0'}`}>
            <h2 className="font-display text-3xl md:text-4xl font-bold text-slate-900 mb-4">
              Software Built for <span className="gradient-text">Real Business Challenges</span>
            </h2>
            <p className="text-slate-600 text-lg max-w-2xl mx-auto">
              Each Scalizap product is backed by years of industry experience and continuously refined based on real customer feedback.
            </p>
          </div>

          <div className="space-y-16">
            {products.map((product, i) => (
              <div
                key={i}
                className={`bg-white rounded-3xl shadow-lg overflow-hidden ${isVisible ? 'animate-fadeInUp' : 'opacity-0'}`}
                style={{ animationDelay: `${i * 0.1}s` }}
              >
                <div className={`h-2 bg-gradient-to-r ${product.gradient}`}></div>
                <div className="p-8 md:p-12">
                  <div className="grid lg:grid-cols-2 gap-12 items-start">
                    <div>
                      <div className="flex items-center gap-3 mb-4">
                        <div className={`w-16 h-16 bg-gradient-to-br ${product.gradient} rounded-2xl flex items-center justify-center text-white`}>
                          {product.icon}
                        </div>
                        <span className={`text-xs font-semibold px-3 py-1.5 rounded-full ${product.badgeColor}`}>{product.badge}</span>
                      </div>
                      <h2 className="font-display text-2xl md:text-3xl font-bold text-slate-900 mb-2">{product.title}</h2>
                      <p className="text-blue-600 font-medium text-sm mb-4">{product.tagline}</p>
                      <p className="text-slate-600 text-base leading-relaxed mb-6">{product.description}</p>
                      <div className="flex flex-wrap gap-3">
                        <Link
                          to="/contact-us"
                          className={`bg-gradient-to-r ${product.gradient} text-white px-7 py-3 rounded-xl font-semibold text-sm transition-all duration-300 transform hover:scale-105 hover:shadow-lg`}
                        >
                          {product.cta}
                        </Link>
                        <Link
                          to="/contact-us"
                          className="border-2 border-slate-200 text-slate-700 px-7 py-3 rounded-xl font-semibold text-sm hover:bg-slate-50 transition-all duration-300"
                        >
                          Contact Sales
                        </Link>
                      </div>
                    </div>
                    <div>
                      <h3 className="font-bold text-slate-900 mb-4 text-sm uppercase tracking-wide text-slate-500">Key Features</h3>
                      <div className="grid grid-cols-1 gap-3">
                        {product.features.map((feature, j) => (
                          <div key={j} className="flex items-center gap-3 bg-slate-50 rounded-xl px-4 py-3">
                            <svg className="w-4 h-4 text-green-500 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                            </svg>
                            <span className="text-slate-700 text-sm font-medium">{feature}</span>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Custom Development CTA */}
      <section className="section-padding bg-white">
        <div className="container-custom">
          <div className={`bg-gradient-to-br from-slate-900 to-slate-800 rounded-3xl p-10 md:p-16 text-white text-center ${isVisible ? 'animate-fadeInUp' : 'opacity-0'}`}>
            <div className="max-w-2xl mx-auto">
              <h2 className="font-display text-3xl md:text-4xl font-bold mb-4">Need Something Custom?</h2>
              <p className="text-gray-300 text-lg mb-8 leading-relaxed">
                Our products are a great starting point, but every business is unique. We can customize any product or build an entirely bespoke solution designed from scratch around your specific requirements.
              </p>
              <div className="flex flex-wrap justify-center gap-4">
                <Link
                  to="/services/custom-software-development"
                  className="bg-gradient-to-r from-blue-500 to-cyan-400 text-white px-10 py-4 rounded-full font-semibold text-sm transition-all duration-300 transform hover:scale-105 hover:shadow-2xl"
                >
                  Explore Custom Development
                </Link>
                <Link
                  to="/contact-us"
                  className="border-2 border-white/30 text-white px-10 py-4 rounded-full font-semibold text-sm hover:bg-white/10 transition-all duration-300"
                >
                  Talk to Our Team
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
};

export default ProductsPage;
